const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const psArchive =  document.querySelector('body.post-type-archive-policy-scan');
const ps =  document.querySelector('body.single-policy-scan');

function sendCookie() {
  const data = new FormData();
  data.append("action", "wpscan");

  const params1 = new URLSearchParams(data);

  fetch(fp_pscan_params.wp_ajaxurl, {
    method: "POST",
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Cache-Control": "no-cache",
    },
    body: params1,
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (!checkCookie("hs") && params.hs) {
        setCookie("hs", data, 1);
        if (psArchive) psArchive.style.display = 'block';
        if (ps) ps.style.display = 'block';
      } else if (!checkCookie("hs") && !params.hs) {
        console.log('redirect');
        if ( psArchive || ps ) {
           window.location.href = window.location.origin;
        }
      }
      else {
        // cookie is set
        if (psArchive) psArchive.style.display = 'block';
        if (ps) ps.style.display = 'block';
        //console.log('params', params.hs);
      }
    })
    .catch((error) => {
      console.log("Error getting data");
      console.error(error);
    });
}

sendCookie();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie($name) {
  let name = getCookie($name);
  if (name != "") {
    //console.log("hs " + name);
    return name;
  } else {
    return false;
  }
}
